import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { useTranslation } from "@opendash/i18n";
import { Card, Flex, Typography } from "antd";
import dayjs from "dayjs";
import React, { memo, useMemo } from "react";
import { TicketManager, TicketTagBar, useTicketData } from "../../..";
import { getFirstUserMessage } from "../../../../../_shared/messages/functions/getFirstUserMessage";
import { OpenService } from "../../../../../types/config";
import { TicketSourceFilterTag } from "../../../source/components/TicketSourceFilterTag";
import { ColumnContext } from "../../context/ColumnContext";
import { KanbanContext } from "../../context/KanbanContext";
import { Dragger } from "../styled/Dragger";

const { Paragraph } = Typography;

type Props = {
  ticketManager: TicketManager;
  listeners: SyntheticListenerMap;
  isDragging: boolean;
  customReload?: () => void;
};

export const TicketCard = memo((props: Props) => {
  const t = useTranslation();
  const columnId = React.useContext(ColumnContext);
  const kanbanManager = React.useContext(KanbanContext);
  const ticketData = useTicketData();

  const userMessage = useMemo(
    () => getFirstUserMessage(ticketData?.messages)?.get("content"),
    [ticketData?.messages]
  );

  const createdAt = useMemo(
    () => ticketData.ticket.get("createdAt"),
    [ticketData?.ticket]
  );

  const issuecategory = useMemo(
    () => ticketData.issuecategory,
    [ticketData?.issuecategory]
  );

  function reload() {
    kanbanManager.reload(columnId);
  }

  return (
    <Card
      title={
        <Flex justify="space-between" align="center" gap="small">
          <Dragger
            {...props.listeners}
            icon="fa:grip-lines-vertical"
            size={24}
            isdragging={props.isDragging ? "true" : "false"}
            style={{ marginLeft: -24 }}
          />

          <Paragraph style={{ width: "100%", marginBottom: 0 }}>
            {ticketData?.ticket?.get("title")}
          </Paragraph>

          <TicketSourceFilterTag
            filterManager={props.ticketManager}
            onClick={() => reload()}
          />
        </Flex>
      }
      style={{
        marginBottom: "20px",
      }}
      styles={{ title: { overflow: "visible" } }}
      actions={[
        <Flex align="center" justify="space-evenly" wrap>
          <TicketTagBar
            reload={props.customReload}
            managers={{ filterManager: props.ticketManager }}
          />
        </Flex>,
      ]}
    >
      <Flex vertical gap={12}>
        {userMessage ? <Typography.Text>{userMessage}</Typography.Text> : null}
        {issuecategory ? (
          <Typography.Text>
            {t("maintenance:ticket.tile.issuecategory", {
              category: issuecategory.get("name"),
            })}
          </Typography.Text>
        ) : null}
        <Typography.Text>
          {t("maintenance:ticket.tile.createdAt", {
            date: dayjs(createdAt).format(OpenService.Formats.datetime),
          })}
        </Typography.Text>
      </Flex>
    </Card>
  );
});
